import { createContext, useContext } from 'react';

export type PageTransitionEntranceContextValue = {
  /**
   * true cuando PageTransition está en fase `idle` (overlay terminado).
   * Las entradas de página deben animar solo cuando es true para no “consumirse” detrás de la transición violeta.
   */
  allowContentEntrance: boolean;
};

const defaultValue: PageTransitionEntranceContextValue = {
  allowContentEntrance: true,
};

export const PageTransitionEntranceContext =
  createContext<PageTransitionEntranceContextValue>(defaultValue);

export function usePageTransitionEntrance(): boolean {
  return useContext(PageTransitionEntranceContext).allowContentEntrance;
}
